export default __webpack_public_path__ + "static/media/Gingelly.1e737f7b.png";